export default __webpack_public_path__ + "static/media/char-chewbacca.932badc6.jpg";